var React = require('react');

function Lead (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.8065 26.0465V22.7907L22.2 27.4419L26.8065 32.093V28.8372H37V26.0465H26.8065ZM32.3935 33.9535H22.2V36.7442H32.3935V40L37 35.3488L32.3935 30.6977V33.9535ZM13.875 7.44186C15.91 7.44186 17.575 5.76744 17.575 3.72093C17.575 1.67442 15.91 0 13.875 0C11.84 0 10.175 1.67442 10.175 3.72093C10.175 5.76744 11.84 7.44186 13.875 7.44186ZM6.9375 13.7674L1.85 40H5.735L8.9725 25.1163L12.95 28.8372V40H16.65V25.9535L12.8575 22.1395L13.9675 16.5581C16.3725 19.5349 19.98 21.3953 24.05 21.3953V17.6744C20.6275 17.6744 17.6675 15.814 16.0025 13.1163L14.245 10.1395C13.5975 9.02326 12.395 8.37209 11.1 8.37209C10.6375 8.37209 10.175 8.46512 9.7125 8.65116L0 12.6512V21.3953H3.7V15.1628L6.9375 13.7674Z","fill":"currentColor"}));
}

Lead.defaultProps = {"width":"37","height":"40","viewBox":"0 0 37 40","fill":"none"};

module.exports = Lead;

Lead.default = Lead;
